import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import {
  DataScheduleProfessionalModel,
  ScheduleProfessionalModel,
} from '../../models/configuration/schedule-professional.model';
import { ConfigurationRepository } from '../../repositories/configuration.repository';

export class UpdateScheduleProfessionalUseCase
  implements UseCase<DataScheduleProfessionalModel[], ScheduleProfessionalModel>
{
  constructor(private configurationRepository: ConfigurationRepository) {}

  execute(
    params: DataScheduleProfessionalModel[]
  ): Observable<ScheduleProfessionalModel> {
    return this.configurationRepository.updateScheduleProfessional(params);
  }
}